import { useAppSelector } from '../hooks'
import { selectAccountId } from '../auth/authSlice'
import { useGetOnboardingFlowQuery } from './onboarding'
import { OnboardingFlowStatus, OnboardingFlowType } from '../../models/Onboarding'
import { skipToken } from '@reduxjs/toolkit/query'

interface UseIsOnboardingActiveResult {
  isLoading: boolean
  isActive: boolean
}

export const useIsOnboardingActive = (): UseIsOnboardingActiveResult => {
  const accountId = useAppSelector(selectAccountId)
  const { data, isLoading } = useGetOnboardingFlowQuery(accountId ? { accountId, flowType: OnboardingFlowType.DEFAULT } : skipToken)

  return {
    isLoading,
    isActive: data?.data.status === OnboardingFlowStatus.ACTIVE,
  }
}
